var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 23.9831C18.6143 23.9831 23.9831 18.6143 23.9831 11.9915C23.9831 5.3688 18.6143 0 11.9915 0C5.3688 0 0 5.3688 0 11.9915C0 18.6143 5.3688 23.9831 11.9915 23.9831Z",
    fill: "#7D2AE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 23.9831C18.6143 23.9831 23.9831 18.6143 23.9831 11.9915C23.9831 5.3688 18.6143 0 11.9915 0C5.3688 0 0 5.3688 0 11.9915C0 18.6143 5.3688 23.9831 11.9915 23.9831Z",
    fill: "url(#paint0_radial_149_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 23.9831C18.6143 23.9831 23.9831 18.6143 23.9831 11.9915C23.9831 5.3688 18.6143 0 11.9915 0C5.3688 0 0 5.3688 0 11.9915C0 18.6143 5.3688 23.9831 11.9915 23.9831Z",
    fill: "url(#paint1_radial_149_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 23.9831C18.6143 23.9831 23.9831 18.6143 23.9831 11.9915C23.9831 5.3688 18.6143 0 11.9915 0C5.3688 0 0 5.3688 0 11.9915C0 18.6143 5.3688 23.9831 11.9915 23.9831Z",
    fill: "url(#paint2_radial_149_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 23.9831C18.6143 23.9831 23.9831 18.6143 23.9831 11.9915C23.9831 5.3688 18.6143 0 11.9915 0C5.3688 0 0 5.3688 0 11.9915C0 18.6143 5.3688 23.9831 11.9915 23.9831Z",
    fill: "url(#paint3_radial_149_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1058 13.0795C21.0744 13.0795 21.0457 13.0998 21.0309 13.1424C20.8415 13.6831 20.5854 14.0047 20.3747 14.0047C20.2536 14.0047 20.2046 13.8698 20.2046 13.6582C20.2046 13.1286 20.5216 12.0055 20.6815 11.4934C20.7 11.4315 20.712 11.376 20.712 11.3289C20.712 11.1801 20.6307 11.107 20.4292 11.107C20.212 11.107 19.9782 11.1921 19.7508 11.5905C19.6722 11.2392 19.4347 11.0858 19.1028 11.0858C18.7192 11.0858 18.3486 11.3326 18.0436 11.7328C17.7386 12.133 17.3799 12.2643 17.11 12.1996C17.3041 11.7245 17.3762 11.3695 17.3762 11.1061C17.3762 10.6929 17.1719 10.4434 16.842 10.4434C16.34 10.4434 16.0508 10.9222 16.0508 11.4259C16.0508 11.8151 16.2273 12.2153 16.6155 12.4094C16.2901 13.1451 15.8151 13.8107 15.6348 13.8107C15.4019 13.8107 15.3334 12.671 15.3464 11.8557C15.3547 11.388 15.3935 11.364 15.3935 11.2226C15.3935 11.1412 15.3409 11.0858 15.1292 11.0858C14.6356 11.0858 14.4831 11.5036 14.46 11.9833C14.4525 12.1656 14.424 12.3464 14.375 12.5222C14.1688 13.2579 13.7436 13.8162 13.4664 13.8162C13.3379 13.8162 13.3028 13.6877 13.3028 13.5195C13.3028 12.9899 13.5994 12.3281 13.5994 11.7633C13.5994 11.3483 13.4174 11.0858 13.0745 11.0858C12.6705 11.0858 12.1363 11.5664 11.6307 12.4667C11.797 11.7772 11.8655 11.1098 11.3728 11.1098C11.2659 11.1114 11.161 11.1387 11.0668 11.1893C11.0353 11.2042 11.0089 11.2281 10.9911 11.2581C10.9733 11.2881 10.9649 11.3227 10.967 11.3575C11.0142 12.0915 10.3755 13.9715 9.77003 13.9715C9.66005 13.9715 9.60643 13.8522 9.60643 13.66C9.60643 13.1295 9.92254 12.0092 10.0815 11.4962C10.1018 11.4296 10.113 11.3723 10.113 11.3224C10.113 11.1819 10.026 11.1098 9.82918 11.1098C9.6129 11.1098 9.37814 11.1921 9.1517 11.5905C9.07219 11.2392 8.83465 11.0858 8.5028 11.0858C7.95841 11.0858 7.35019 11.6617 7.08307 12.4122C6.72534 13.4141 6.00439 14.3819 5.03386 14.3819C4.15299 14.3819 3.68806 13.6489 3.68806 12.4907C3.68806 10.8187 4.91556 9.45254 5.826 9.45254C6.26135 9.45254 6.46932 9.72982 6.46932 10.155C6.46932 10.6698 6.18184 10.9092 6.18184 11.1052C6.18184 11.1653 6.23178 11.2244 6.33066 11.2244C6.72628 11.2244 7.19211 10.7595 7.19211 10.1254C7.19211 9.49133 6.67729 9.02734 5.76685 9.02734C4.26208 9.02734 2.74805 10.5414 2.74805 12.4815C2.74805 14.0251 3.50967 14.9559 4.82679 14.9559C5.72523 14.9559 6.51 14.2571 6.93331 13.4418C6.9814 14.1175 7.28825 14.4706 7.75597 14.4706C8.17191 14.4706 8.50833 14.2229 8.76529 13.7876C8.86422 14.2432 9.12671 14.466 9.46781 14.466C9.85876 14.466 10.186 14.2183 10.4974 13.758C10.4929 14.1194 10.5751 14.4596 10.8884 14.4596C11.0363 14.4596 11.2129 14.4253 11.2443 14.2959C11.5743 12.9316 12.3895 11.8178 12.6391 11.8178C12.7131 11.8178 12.7334 11.889 12.7334 11.9731C12.7334 12.3438 12.4718 13.1036 12.4718 13.5889C12.4718 14.1129 12.6946 14.4596 13.1549 14.4596C13.6651 14.4596 14.1836 13.8347 14.5293 12.9215C14.6375 13.7746 14.8714 14.4632 15.2374 14.4632C15.6866 14.4632 16.4842 13.5177 16.9677 12.5166C17.1571 12.5407 17.4418 12.5342 17.7154 12.341C17.5989 12.6358 17.5306 12.9585 17.5306 13.281C17.5306 14.21 17.9742 14.4706 18.3559 14.4706C18.771 14.4706 19.1074 14.2229 19.3653 13.7876C19.4503 14.1804 19.6676 14.465 20.0669 14.465C20.6917 14.465 21.2343 13.8264 21.2343 13.3023C21.2343 13.1637 21.1751 13.0795 21.1058 13.0795ZM8.1368 13.9558C7.88443 13.9558 7.78554 13.7016 7.78554 13.3226C7.78554 12.6645 8.23569 11.5655 8.71172 11.5655C8.91969 11.5655 8.99825 11.8104 8.99825 12.1099C8.99825 12.7782 8.57031 13.9558 8.1368 13.9558ZM16.78 11.9916C16.6294 11.8123 16.5748 11.5683 16.5748 11.351C16.5748 11.083 16.6728 10.8565 16.7902 10.8565C16.9076 10.8565 16.9436 10.9721 16.9436 11.1329C16.9436 11.4019 16.8475 11.7947 16.78 11.9916ZM18.7368 13.9558C18.4845 13.9558 18.3856 13.6637 18.3856 13.3226C18.3856 12.6876 18.8357 11.5655 19.3154 11.5655C19.5234 11.5655 19.5973 11.8086 19.5973 12.1099C19.5973 12.7782 19.1768 13.9558 18.7368 13.9558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_149_35",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.62563 21.2567) rotate(-49.416) scale(18.5489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_149_35",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.34916 2.72644) rotate(54.703) scale(20.9173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_149_35",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.63252 21.2566) rotate(-45.1954) scale(18.3243 8.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_149_35",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.80782 3.2314) rotate(66.5198) scale(18.8818 31.6312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanva);
export default __webpack_public_path__ + "static/media/canva.1319df3baeb3e9a02f489a6cabaa29c4.svg";
export { ForwardRef as ReactComponent };